import { TreeSelect as AntdTreeSelect } from 'antd';
import { createGuardedComponent } from '../../provider/create-guarded-component';

export type { TreeSelectProps } from 'antd';

export const TreeSelect = createGuardedComponent(AntdTreeSelect) as typeof AntdTreeSelect;
